/* eslint-disable max-len */
import { useState } from "react";
import { Link } from "react-router-dom";
import { useSidebarState } from "react-admin";
import { BurgerIcon, CloseIcon } from "assets/Icons";
import logo from "assets/Logo.svg";
import * as User from "providers/user";
import { Avatar, Popover } from "@mui/material";
import LogoutAndLanguage from "./LogoutAndLanguage";
import ImpersonateHeader from "./ImpersonateHeader";

export const CustomAppBar = (props: any) => {
  const { user } = User.useUser();
  const [open, setOpen] = useSidebarState();
  const [anchorEl, setAnchorEl] = useState<HTMLDivElement | null>(null);

  const handleClosePopover = (): void => {
    setAnchorEl(null);
  };

  const isPopoverOpen = Boolean(anchorEl);
  const id = isPopoverOpen ? "profile-popover" : undefined;

  const handleProfileClick = (
    event: React.MouseEvent<HTMLDivElement>
  ): void => {
    setAnchorEl(event.currentTarget);
  };

  return (
    <>
      <div className="mb-[64px] relative lg:hidden md:hidden sm:hidden">
        <div className="absolute w-full top-[64px] left-0 z-50 justify-end flex">
          {user.impersonate_company_id && (
            <ImpersonateHeader
              fixedWidth
              customClasses={{
                container: "w-full",
                message: "truncate mr-2"
              }}
            />
          )}
        </div>
        <div
          className="w-full h-[64px] justify-between items-center flex
        fixed top-0 left-0 px-[16px] bg-[#FAF9F7] border border-[#E8E2DA] z-50"
        >
          <div
            onClick={() => setOpen(!open)}
            aria-hidden
            className="cursor-pointer"
            guide-id="burger-menu-button"
          >
            {open ? <CloseIcon /> : <BurgerIcon />}
          </div>
          <Link to="/dashboard">
            <div className="w-[134px]">
              <img className="w-[134px] h-[32px]" src={logo} alt="logo" />
            </div>
          </Link>
          <div
            onClick={handleProfileClick}
            aria-hidden
            className="cursor-pointer"
          >
            {user?.photo_url ? (
              <img
                className="w-[24px] h-[24px] rounded-[12px] object-cover"
                src={user?.photo_url}
                alt="avatar"
              />
            ) : (
              <Avatar
                sx={{
                  bgcolor: "#B0ACA6",
                  width: "24px",
                  height: "24px",
                  fontFamily: "Inter",
                  fontSize: "12px",
                  fontWeight: 400
                }}
              >
                {`${user?.first_name[0]}${user?.last_name[0]}`.toUpperCase()}
              </Avatar>
            )}
          </div>
          <Popover
            id={id}
            open={isPopoverOpen}
            anchorEl={anchorEl}
            onClose={handleClosePopover}
            elevation={3}
            sx={{
              "& .MuiPopover-paper": {
                backgroundColor: "#fff",
                borderRadius: "4px",
                padding: "0px"
              }
            }}
            anchorOrigin={{
              vertical: 180,
              horizontal: "left"
            }}
            transformOrigin={{
              vertical: "bottom",
              horizontal: "left"
            }}
          >
            <LogoutAndLanguage
              isMobileView
              closeProfilePopover={handleClosePopover}
            />
          </Popover>
        </div>
      </div>
      {user.impersonate_company_id && (
        <div className="fixed w-full top-0 right-0 z-10 justify-end hidden sm:flex">
          <ImpersonateHeader open={open} />
        </div>
      )}
    </>
  );
};
